module.exports = __webpack_public_path__ + "static/media/ginza.02aa6a46.jpg";